import { GridRowParams } from '@mui/x-data-grid-premium'
import { generateRequestDetailRoute, RequestTabs } from '@omnea-app/fe-requests/requestRoutes'
import { useSafePush } from '@omnea-app/fe-routing/useSafePush'
import { DataGridBase } from '@omnea-app/fe-tables/data-grid/DataGridBase'
import { SourcingEventRow, useRfxColumns } from './useRfxColumns'

const isSelectedColumn = (columnName: string, visibleColumns: string[]) => {
  return visibleColumns.includes(columnName)
}

interface Props {
  rows: SourcingEventRow[]
}

export const RfxDataGrid = ({ rows }: Props) => {
  const { safeUrlPush } = useSafePush()
  const rfxColumns = useRfxColumns({ sortable: false })

  const onRowClick = ({ kind, requestId }: SourcingEventRow) => {
    void safeUrlPush(generateRequestDetailRoute(kind === 'AUCTION' ? RequestTabs.AUCTIONS : RequestTabs.RFX, requestId))
  }

  const visibleColumns = ['requestName', 'status', 'deadlineType', 'dueDate']

  const columns = rfxColumns.filter((column) => isSelectedColumn(column.field, visibleColumns))

  return (
    <DataGridBase
      disableColumnResize
      rows={rows}
      hideFooter
      columns={columns.map((column) => ({ ...column, flex: 0.25, minWidth: 160 }))}
      onRowClick={({ row }: GridRowParams<SourcingEventRow>) => onRowClick(row)}
      sx={{
        backgroundColor: 'none',
      }}
    />
  )
}
